var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ar-manager"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"用户管理","name":"ar"}},[(_vm.isAr)?_c('Ar'):_vm._e()],1),_c('el-tab-pane',{attrs:{"label":"场管理列表","name":"group"}},[(!_vm.isAr)?_c('Group'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }